/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {SelectDropdownOptionModel} from '../../shared/select-dropdown/models/select-dropdown-option.model';
import {InputCriteriaDateCodeEnum} from './input-criteria-date-code.enum';

export const InputCriteriaDateConfiguration: {
    readonly dropdownDefaultButtonText: string;
    readonly dropdownData: readonly SelectDropdownOptionModel[];
} = {
    dropdownDefaultButtonText: 'Select time period type',
    dropdownData: [
        {
            code: InputCriteriaDateCodeEnum.GREATER_OR_EQUAL,
            name: 'Start date is equal or after then',
            resultPrefix: 'Start date is equal or after then'

        },
        {
            code: InputCriteriaDateCodeEnum.LESS_OR_EQUAL,
            name: 'End date is equal or before then',
            resultPrefix: 'End date is equal or before then'
        },
        {
            code: InputCriteriaDateCodeEnum.BETWEEN_INTERVAL,
            name: 'Period contained in',
            resultPrefix: 'Contained in'
        }
    ]
};
